import React, { useState, useEffect, useRef } from 'react';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';

/**
 * StableInput: A memo'd input wrapper that manages its own local state.
 * Prevents focus loss during parent re-renders by isolating the input's
 * value management from React's reconciliation cycle.
 */
export const StableInput = React.memo(function StableInput({
  value: externalValue,
  onChange,
  field,
  ...props
}) {
  const [localValue, setLocalValue] = useState(externalValue ?? '');
  const isTyping = useRef(false);

  // Sync from parent only when NOT actively typing
  useEffect(() => {
    if (!isTyping.current) {
      setLocalValue(externalValue ?? '');
    }
  }, [externalValue]);

  const handleChange = (e) => {
    isTyping.current = true;
    const val = e.target.value;
    setLocalValue(val);
    if (onChange) onChange(field, val);
  };

  const handleBlur = () => {
    isTyping.current = false;
  };

  return (
    <Input
      {...props}
      value={localValue}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
});

export const StableTextarea = React.memo(function StableTextarea({
  value: externalValue,
  onChange,
  field,
  ...props
}) {
  const [localValue, setLocalValue] = useState(externalValue ?? '');
  const isTyping = useRef(false);

  useEffect(() => {
    if (!isTyping.current) {
      setLocalValue(externalValue ?? '');
    }
  }, [externalValue]);

  const handleChange = (e) => {
    isTyping.current = true;
    const val = e.target.value;
    setLocalValue(val);
    if (onChange) onChange(field, val);
  };

  const handleBlur = () => {
    isTyping.current = false;
  };

  return (
    <Textarea
      {...props}
      value={localValue}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
});
